"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Text = require("../../Ui/Text");

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || typeof obj !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var __jsx = _react["default"].createElement;

var GroupContainer = _styledComponents["default"].fieldset.withConfig({
  displayName: "FieldGroup__GroupContainer",
  componentId: "nul19d-0"
})(["border:2px solid #7d6aee;border-radius:16px;padding:34px;padding-top:24px;", " & + &{margin-top:", ";}"], function (_ref) {
  var theme = _ref.theme;
  return theme.mode === 'dark' && (0, _styledComponents.css)(["border:none;background-color:var(--colors-blank);box-shadow:0px 8px 30px rgba(0,0,0,0.08);"]);
}, function (_ref2) {
  var biggerMargin = _ref2.biggerMargin;
  return biggerMargin ? '52px' : '29px';
});

var GroupLabel = _styledComponents["default"].div.withConfig({
  displayName: "FieldGroup__GroupLabel",
  componentId: "nul19d-1"
})(["flex-basis:100%;opacity:0.8;margin-bottom:12px;font-size:14px;"]);

function FieldGroup(_ref3) {
  var children = _ref3.children,
      label = _ref3.label;

  if (!children) {
    return null;
  }

  return __jsx(GroupContainer, null, __jsx(_Text.SROnly, {
    as: "legend"
  }, label), __jsx(GroupLabel, {
    "aria-hidden": "true"
  }, label), children);
}

var _default = FieldGroup;
exports["default"] = _default;